import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'
import { useSelector } from 'react-redux'

export function getValidationSchema() {
  const t = useTrans()
  const serviceGift = useSelector((state) => state?.servicegift?.service_gift)
  return yup.object().shape({
    utente: yup
      .object({
        nome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
        cognome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
        email: yup
          .string()
          .email(t("L'email deve essere valida"))
          .required(t('Questo campo è obbligatorio'))
          .nullable(),
        telefono: yup
          .string()
          .required(t('Questo campo è obbligatorio'))
          .min(8, t('Minimo {0} caratteri', [8]))
          .nullable(),
      })
      .required(),
    credenziali: yup.object({
      username: yup
        .string()
        .email("L'email deve essere valida")
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      password: yup
        .string()
        .label('Password')
        .required(t('Questo campo è obbligatorio'))
        .min(6, t('Minimo {0} caratteri', [6]))
        .nullable(),
      conferma_password: yup
        .string()
        .required(t('Questo campo è obbligatorio'))
        .label(t('Conferma Password'))
        .test('passwords-match', t('Le due password dovrebbero coincidere'), function (value) {
          return this.parent.password === value
        })
        .nullable(),
    }),
    dati_aziendali: yup.object({
      ragione_sociale: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
      email: yup
        .string()
        .email(t("L'email deve essere valida"))
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      telefono: yup
        .string()
        .min(8, t('Minimo {0} caratteri', [8]))
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      partita_iva: yup
        .string()
        .required(t('Questo campo è obbligatorio'))
        .max(11, t('Massimo {0} caratteri', [11])),
      indirizzo: yup
        .string()
        .max(35, t('Troppo lungo'))
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      cap: yup
        .string()
        .min(5, t('Minimo {0} caratteri', [5]))
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      citta: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
      nazione_id: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
      provincia: yup
        .string()
        .when('withProvincia', {
          is: true,
          then: yup.string().nullable(),
        })
        .nullable(),
    }),
    info_aggiuntive: yup.object({
      sottocanale_commerciale_id: yup.string().nullable(),
    }),
    autorizzazioni: yup.object({
      // privacy: serviceGift
      //   ? yup.bool().nullable()
      //   : yup.bool().oneOf([true], t('Bisogno accettare')),
      privacy_commerciale: yup.bool().nullable(),
      // privacy_profilazione: yup.bool().nullable(),
    }),
  })
}

export function getValidationSchemaAdmin() {
  const t = useTrans()
  const serviceGift = useSelector((state) => state?.servicegift?.service_gift)
  return yup.object().shape({
    utente: yup
      .object({
        nome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
        cognome: yup.string().required(t('Questo campo è obbligatorio')).nullable(),
        email: yup
          .string()
          .email(t("L'email deve essere valida"))
          .required(t('Questo campo è obbligatorio'))
          .nullable(),
        telefono: yup
          .string()
          .required(t('Questo campo è obbligatorio'))
          .min(8, t('Minimo {0} caratteri', [8]))
          .nullable(),
      })
      .required(),
    credenziali: yup.object({
      username: yup
        .string()
        .email("L'email deve essere valida")
        .required(t('Questo campo è obbligatorio'))
        .nullable(),
      password: yup
        .string()
        .label('Password')
        .required(t('Questo campo è obbligatorio'))
        .min(6, t('Minimo {0} caratteri', [6]))
        .nullable(),
      conferma_password: yup
        .string()
        .required(t('Questo campo è obbligatorio'))
        .label(t('Conferma Password'))
        .test('passwords-match', t('Le due password dovrebbero coincidere'), function (value) {
          return this.parent.password === value
        })
        .nullable(),
    }),
    autorizzazioni: yup.object({
      // http://project.webranking.it/#/tasks/27490340
      // privacy: serviceGift
      //   ? yup.bool().nullable()
      //   : yup.bool().oneOf([true], t('Bisogno accettare')),
      privacy_commerciale: yup.bool().nullable(),
      // privacy_profilazione: yup.bool().nullable(),
    }),
  })
}
